import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Control, FieldValues } from "react-hook-form";
import { SliderWithInput } from "./SliderWithInput";

type SliderWithAccordionProps<T extends FieldValues> = {
  name: string;
  label: string;
  description: string;
  control: Control<T>;
};

export const SliderWithAccordion = <T extends FieldValues>({
  name,
  label,
  description,
  control,
}: SliderWithAccordionProps<T>) => {
  const firstPeriodIndex = description.indexOf(".");
  const firstSentence = description.substring(0, firstPeriodIndex + 1);
  const remainingText = description.substring(firstPeriodIndex + 1).trim();

  return (
    <Box mb={2}>
      <SliderWithInput
        name={name}
        label={label}
        control={control}
        hideLabel
        min={0}
        max={100}
        step={5}
      />
      <Accordion sx={{ mt: 2 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`${name}-content`}
          id={`${name}-header`}
        >
          <Typography sx={{ maxWidth: "100%" }}>{firstSentence}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>{remainingText}</Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
